//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.DimensionBuilder.js";
import "../no/SelectNXObject.js";
import "../no/ugmath.js";
import "../no/SelectObject.js";
let d=[[[0,"AlternativeAngle",1,0],[0,"ComplementAngleFlag",1,0],[1,"MeasurementObject",0,"SelectNXObject",0],[1,"OriginObject",0,"SelectNXObject",0]],[[["dimensionLocation"],"GetIsComplementAngle",{R_:{isComplementAngle:''}},1,0],[["interpartSourceEdge"],"SetInterpartSourceEdge",{},1,0]],[]];
SPLM.Features.AngularDimBuilder = class extends SPLM.Features.DimensionBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.AngularDimBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;